import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IEventChecklist } from '@clickersphere/core/entities/IEventChecklist';
import EventChecklistService from '@clickersphere/core/services/EventChecklistService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const EVENT_CHECKLISTS_QUERY_KEY = 'event-checklists';

export type EventChecklistQueryData = WithQueryStatus<IEventChecklist>;

export function useEventChecklists() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: eventChecklists,
    isSuccess: isEventChecklistsSuccess,
    isFetching: isEventChecklistsFetching,
    isLoading: isEventChecklistsLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(EVENT_CHECKLISTS_QUERY_KEY),
    queryFn: async () => {
      const result = await EventChecklistService.getAll();
      return result as EventChecklistQueryData[];
    },
    select: (data) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
  });

  return {
    eventChecklists: eventChecklists ?? [],
    isEventChecklistsSuccess,
    isEventChecklistsFetching,
    isEventChecklistsLoading,
  };
}
